import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { getTranslation } from '../../../assets/creator/translations';

const errorHeaderContent = () => (
    <React.Fragment>
        <FontAwesomeIcon className="notification__icon notification__icon__error" color="#fff" icon={faExclamationCircle} />
        <span className='notification__text'>{getTranslation("Clv_MessageErrorColor")}</span>
    </React.Fragment>
);

const successHeaderContent = () => (
    <React.Fragment>
        <FontAwesomeIcon className="notification__icon notification__icon__success" color="#fff" icon={faCheckCircle} />
        <span>{getTranslation("Ntf_SuccessHeader")}</span>
    </React.Fragment>
)
const getNotificationHeaderByType = (type) => {
    switch (type) {
        case 'error':
            return errorHeaderContent();
        case 'success':
            return successHeaderContent();
        default: return null
    }
}

const NotificationHeader = ({ type, title }) => (
     <div className="notification__header">
        {getNotificationHeaderByType(type) || title}
    </div>
)

const Notification = ({ type, title, message, onClick }) => {
    const msg = getTranslation(message);
    
    let notificationClassName = 'notification';
    if (type) {
        notificationClassName = notificationClassName + ' notification--' + type;
    }
    
    let timerAnimationClassName = 'timer-animation';
    if (type) {
        timerAnimationClassName = timerAnimationClassName + ' timer-animation--' + type;
    }
    
    return (<div
        className={notificationClassName}
        onClick={onClick}
    >   
        <NotificationHeader type={type} title={title} />
        <div className="notification__body">
            {msg && msg.split('\n').map((item,i) => <p key={i}>{item}</p>)}
            
        </div>
        <span className={timerAnimationClassName}></span>
        {/* <span className={` timer-animation-2 ${type? "timer-animation-2--"+type:"" }`}></span> */}
    </div>
    );
}

export default Notification;